enum ModalType {
    Show = "modal/SHOW",
    Hide = "modal/HIDE",
}

export default ModalType;
